import qs from 'qs'

export const isProd = ENV_IS_PRODUCTION || false

export const getTestingEnv = () => {
    const { testing: isTestingEnvironment } = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
    })

    let geoAppTestingFromLocalStorage

    try {
        geoAppTestingFromLocalStorage = localStorage.getItem('geoAppTesting')

        if (isTestingEnvironment && !geoAppTestingFromLocalStorage) {
            localStorage.setItem('geoAppTesting', true)
        }
    } catch (e) {
        geoAppTestingFromLocalStorage = false
    }

    return !!isTestingEnvironment || geoAppTestingFromLocalStorage
}

export const getMaxTextureSize = () => {
    const { maxTextureSize } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    return parseInt(maxTextureSize, 10) || null
}

export const getMemoryTrackingEnv = () => {
    const { memoryTrackingEnv } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    return memoryTrackingEnv
}

export default ENV_MODE
